import { render, staticRenderFns } from "./ProductivityScanning.vue?vue&type=template&id=71d92c21"
import script from "./ProductivityScanning.vue?vue&type=script&lang=js"
export * from "./ProductivityScanning.vue?vue&type=script&lang=js"
import style0 from "./ProductivityScanning.vue?vue&type=style&index=0&id=71d92c21&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports